<template>
  <!-- 学习模式 -->
  <div class="learning-model">
    <div class="learning-model_div">
      <div class="home-title">
        <img src="@/assets/left.png" alt="">
        <div class="home-title-main">
          <p> 美课教育</p>
          <p> 不仅是专业课堂，更是艺术人生</p>
        </div>
        <img src="@/assets/right.png" alt="">
      </div>
      <div class="youshi_box">

        <div class="youshi_item youshi_item0">
          <div class="youshi_img_box youshi_img_box_fang">
            <div class="youshi_img">
              <img src="@/assets/img21.png" alt="" class="youshi_in_img">
              <span class="youshi_title">在线直播教学</span>
            </div>
          </div>
          <div class="youshi_box_text">
            直播讲师在线辅导，伴随式学习服务高清镜头直播教学，讲师线上演示全过程，学员在线互动提问。
          </div>
        </div>
        <div class="youshi_item youshi_item1">
          <div class="youshi_img_box youshi_img_box_fang">
            <div class="youshi_img">
              <img src="@/assets/img20.png" alt="" class="youshi_in_img">
              <span class="youshi_title">丰富的多元化课程</span>
            </div>
          </div>
          <div class="youshi_box_text">
            拥有丰富的多元化课程，课程内容丰富，多种课程供学员选择，名师在线讲解，与学生互动学习！
          </div>
        </div>
        <div class="youshi_item youshi_item2">
          <div class="youshi_img_box youshi_img_box_fang">
            <div class="youshi_img">
              <img src="@/assets/img22.png" alt="" class="youshi_in_img">
              <span class="youshi_title">伴随式学习辅导</span>
            </div>
          </div>
          <div class="youshi_box_text">
            课后班主任悉心辅导，伴随式学习服务，为学员在线答疑！
          </div>
        </div>
        <div class="youshi_item youshi_item3">
          <div class="youshi_img_box youshi_img_box_fang">
            <div class="youshi_img">
              <img src="@/assets/img23.png" alt="" class="youshi_in_img">
              <span class="youshi_title">可循环听课</span>
            </div>
          </div>
          <div class="youshi_box_text">
            课堂直播录课，学员可以根据自己的实际情况，随时随地，循环听课。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  // import slider components
  export default {
    name: 'models',
    data() {
      return {
        msg: '123'
      }
    }
  }
</script>
<style scoped>
  /********** 学习模式 **********/
  .learning-model {
    background-color: rgb(255, 255, 255);
    width: 100%;
    height: auto;
    margin: 10px auto;
  }

  .learning-model_div {
    height: 100%;
  }

  .youshi_box {
    display: flex;
    justify-content: space-between;
    width: 1200px;
    margin: 50px auto;
  }

  .youshi_item {
    width: 256px;
    height: 333px;
    border-radius: 20px;
    background: #fff;
    cursor: pointer;
  }

  .youshi_item {
    box-shadow: rgb(204 204 204 / 35%) 0px 0px 40px 2px
  }

  .youshi_box_text {
    padding: 20px 15px 0px;
    color: rgb(102, 102, 102);
    font-size: 16px;
  }

  .youshi_item0 .youshi_img_box_fang {
    background: linear-gradient(270deg, #6CD9FC, #5699FF);
  }

  .youshi_item1 .youshi_img_box_fang {
    background: linear-gradient(270deg, #BF9CFE, #7869F8);
  }

  .youshi_item2 .youshi_img_box_fang {
    background: linear-gradient(270deg, #F8C052, #F47987);
  }

  .youshi_item3 .youshi_img_box_fang {
    background: linear-gradient(270deg, #69ECB5, #54C69D);
  }

  .youshi_img_box_fang {
    width: 256px;
    height: 171px;
    border-radius: 20px 20px 0px 0px;
    align-items: center;
    margin: 0 auto;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .youshi_item0 .youshi_in_img {
    width: 62px;
    height: 60px;
  }

  .youshi_item1 .youshi_in_img {
    width: 62px;
    height: 51px;
  }

  .youshi_item2 .youshi_in_img {
    width: 72px;
    height: 52px;
  }

  .youshi_item3 .youshi_in_img {
    width: 63px;
    height: 56px;
  }

  .youshi_img {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    /* left: 50%; */
    top: 50%;
    transform: translateY(-50%);
    /* transform: translate(-50%, -50%);*/
  }

  .youshi_title {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/view/Homes/models.vue